<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="$l('table_search_placeholder')"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="900px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="mini">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_pdcostsOrderStatus') || '成本状态'"
            >
              <dict-select
                v-model="form.listPdcostsOrderStatus"
                url="/sys/common/dict/system"
                :body="{ dictType: 'pdcostsOrderStatus' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="mini"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_orderNo') || '订单编号'">
              <el-input
                v-model.trim="form.orderNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_custOrderNo') || '客户订单编号'"
            >
              <el-input
                v-model.trim="form.custOrderNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_cust') || '下单客户'">
              <dict-select
                v-model="form.listCustCode"
                url="/master/common/dict/customerSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                size="mini"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_endCust') || '终端客户'">
              <dict-select
                v-model="form.listEndCustCode"
                url="/master/common/dict/customerSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                size="mini"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_brand') || '客户品牌'">
              <dict-select
                v-model="form.listBrandCode"
                url="/master/common/dict/brandSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                size="mini"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_orderType') || '订单类型'">
              <dict-select
                v-model="form.listOrderType"
                url="/sys/common/dict/system"
                :body="orderTypeParams"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                size="mini"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_salesPerson') || '业务人员'">
              <dict-select
                v-model="form.listSalesPersonCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                size="mini"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_bizPerson') || '跟单人员'">
              <dict-select
                v-model="form.listBizPersonCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                size="mini"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_orderExecuteType') || '执行方式'"
            >
              <dict-select
                v-model="form.listOrderExecuteType"
                url="/sys/common/dict/system"
                :body="orderExecuteTypeParams"
                :placeholder="$l('INDEX.tips_select_data') || '请选择……'"
                size="mini"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_quotedMethod') || '报价方式'">
              <dict-select
                v-model="form.listQuotedMethod"
                url="/sys/common/dict/system"
                :body="quotedMethodParams"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="mini"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_factoryPaymentTerms') || '工厂付款条件'"
            >
              <dict-select
                v-model="form.listFactoryPaymentTerms"
                url="/master/common/dict/biz"
                :body="paymentTermsParams"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="mini"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="5">
              <el-form-item
                :label="$l('form_label_orderAmount') || '订单成本总价'"
              >
                <br />
                <el-col :span="8">
                  <el-input-number
                    v-model="form.orderAmountStart"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    size="mini"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    v-model="form.orderAmountEnd"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    controls-position="right"
                    style="width: 100%"
                    size="mini"
                    :min="0.01"
                    :step="0.01"
                  ></el-input-number>
                </el-col>
                <el-col :span="7">
                  <dict-select
                    v-model="form.currencyUnit"
                    url="/master/common/dict/biz"
                    :body="{ dictType: 'currencyUnit' }"
                    :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                    filterable
                    clearable
                    size="mini"
                    style="width:100%"
                  ></dict-select>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item :label="$l('form_label_deliveryDay') || '交货日期'">
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.deliveryDayStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.deliveryDayEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item :label="$l('form_label_createTime') || '创建时间'">
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item :label="$l('form_label_modifyTime') || '修改时间'">
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 初始表单
const initForm = { keyword: '', listPdcostsOrderStatus: ['N', 'S', 'R', 'Y'] }
export default {
  data() {
    return {
      orderTypeParams: { dictType: 'orderType' },
      paymentTermsParams: { dictType: 'paymentTerms' },
      orderExecuteTypeParams: { dictType: 'orderExecuteType' },
      quotedMethodParams: { dictType: 'quotedMethod' },
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
